//使用axios请求数据
import axios from "axios"
//配置基础路径




/*轮播图*/
let getBanner=(data)=>{
  return axios.post("/banner/listing",data);
};
/* 景区动态 */
let getActivityList=(data)=>{
  return axios.post("/article/listing",data);
};
/* 景区活动 */
let messageActivityList=(data)=>{
  return axios.post("/article/activity/listing",data);
};

/*景区列表*/
let getBusinessHours=(data)=>{
  return axios.post("/business_hours/listing",data);
};
/*景点列表*/
let getScenicSpot=(data)=>{
  return axios.post("/scenic_spot/listing",data);
};
/*景点详情*/
let scenicSpotDetail=(data)=>{
  return axios.post("/scenic_spot/detail",data);
};
/*游玩攻略类型*/
let ywglGetType=(data)=>{
  return axios.post("/play_scenic/area/listing",data);
};
/*诗意玉泉列表*/
let poeticJadeSpring=(data)=>{
  return axios.post("/poetic_jade_spring/listing",data);
};
/*底部二维码*/
let commonQrcode=(data)=>{
  return axios.post("/common/qrcode/listing",data);
};
/* 景区详情 */
let scenicAreaDetail=(data)=>{
  return axios.post("/business_hours/detail",data);
};
/* 文物三宝 */
let culturalRelic=(data)=>{
  return axios.post("/cultural_relic/listing",data);
};
/* 植物三宝 */
let botanyList=(data)=>{
  return axios.post("/botany/listing",data);
};
/* 四绝八景 */
let fourWondersList=(data)=>{
  return axios.post("/four_wonders/listing/listing",data);
};
/* 诗意玉泉 */
let poeticJadeSpringDetail=(data)=>{
  return axios.post("/poetic_jade_spring/detail/listing",data);
};
/* 招商合作 */
let companyAttract=(data)=>{
  return axios.post("/company/attract/listing",data);
};
/* 招商合作 */
let companyAttractDetail=(data)=>{
  return axios.post("/company/attract/detail",data);
};
/* 诚聘英才 */
let companyRecruit=(data)=>{
  return axios.post("/company/recruit/listing",data);
};

export {getBanner,getActivityList,messageActivityList,getBusinessHours,getScenicSpot,scenicSpotDetail,ywglGetType,poeticJadeSpring,commonQrcode,scenicAreaDetail,
  culturalRelic,botanyList,poeticJadeSpringDetail,fourWondersList,companyAttract,companyRecruit,companyAttractDetail};



// WEBPACK FOOTER //
// ./src/api/index.js